import CodigoReceitasService from "../../../services/http/services/ConfiguracoesReceitas/CodigoReceitasService";

export const getQuantidadesReceitasIPM = async () => {
    try {
        const response = await CodigoReceitasService.getQuantidadeReceitasCodigo();
        return response.quantidade;
    } catch (error: any) {
        if (error?.message !== 'Requisicao cancelada!') {
            // notification.error({
            //     message: 'Erro',
            //     description: 'Não foi possível buscar a quantidade de receitas IPM!',
            // });
        }
        return null;
    }
};
